module.exports = __webpack_public_path__ + "files/06721de4403f2e12bbb38dee4a698b20.png";